import { Controller } from "@hotwired/stimulus"

/* przykład użycia: app/views/design/uix/stimulus.html.erb */

export default class extends Controller {
  static targets = ["container"]
  static values = {
    outsideOpenId: String,
    teleport: Boolean,
  }

  connect() {
    // Teleport modalu do <body> - element z position:fixed musi być poza kontenerami
    // tworzącymi kontekst stackingu, inaczej overlay nie przykryje navbara (z-50).
    // Przeniesienie elementu wywołuje ponowny connect - przy drugim element jest już w body
    // (warunek poniżej fałszywy). Stare klony po przeładowaniu turbo-frame usuwamy po id.
    if (this.teleportValue && this.element.parentElement !== document.body) {
      const id = this.element.id
      if (id) {
        document.querySelectorAll(`#${CSS.escape(id)}`).forEach((el) => {
          if (el !== this.element) el.remove()
        })
      }
      document.body.appendChild(this.element)
    }

    this.containerTarget.classList.add("hidden")

    if (this.outsideOpenIdValue) {
      // Delegacja na document zamiast bezpośredniego onclick - trigger może pojawić się
      // PO connect (np. wewnątrz leniwie ładowanego turbo-frame, jak wiersz "AI"
      // w dropdownie ustawień tabeli). Delegacja łapie też triggery dodane później.
      this._onTriggerClick = (e) => {
        if (e.target.closest(`#${CSS.escape(this.outsideOpenIdValue)}`)) this.open()
      }
      document.addEventListener("click", this._onTriggerClick)
    }
  }

  disconnect() {
    if (this._onTriggerClick) {
      document.removeEventListener("click", this._onTriggerClick)
      this._onTriggerClick = null
    }
  }

  open() {
    this.containerTarget.style.display = "block"
    this._onKeydown = (e) => { if (e.key === "Escape") this.hide(e) }
    document.addEventListener("keydown", this._onKeydown)
  }

  hide() {
    this.containerTarget.style.display = "none"
    if (this._onKeydown) {
      document.removeEventListener("keydown", this._onKeydown)
      this._onKeydown = null
    }
  }
}
